'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getAgentTypeFromAudit, getAgentIdFromAudit, getAssignedAgentId, getAssignedAgentType } from 'conversations-message-history/assignment-update-message/operators/assignmentGetters';
import PropTypes from 'prop-types';
import DashedLabel from '../atoms/DashedLabel';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import { agentTypeToSenderType } from 'conversations-message-history/senders/operators/agentTypeToSenderType';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import AssignmentLabel from './AssignmentLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export const AssignmentMessage = ({
  userId,
  message,
  senders
}) => {
  const assignorId = getAgentIdFromAudit(message);
  const assignorType = agentTypeToSenderType(getAgentTypeFromAudit(message));
  const assigneeId = getAssignedAgentId(message);
  const assigneeType = agentTypeToSenderType(getAssignedAgentType(message));
  const assignorAsyncSender = findSender(assignorId, assignorType, senders);
  const assigneeAsyncSender = findSender(assigneeId, assigneeType, senders);
  const isLoading = isSenderLoading(assignorAsyncSender) || isSenderLoading(assigneeAsyncSender);
  return /*#__PURE__*/_jsx(DashedLabel, {
    transparent: true,
    "data-test-id": 'assignment-message',
    children: /*#__PURE__*/_jsx(AssignmentLabel, {
      activeAgentId: `${userId}`,
      assignorSender: getData(assignorAsyncSender),
      assigneeSender: getData(assigneeAsyncSender),
      isLoading: isLoading,
      timestamp: getTimestamp(message)
    })
  });
};
AssignmentMessage.displayName = 'AssignmentMessage';
AssignmentMessage.propTypes = {
  message: RecordPropType('AssignmentUpdateMessage').isRequired,
  senders: SenderMap,
  userId: PropTypes.number.isRequired
};
export default AssignmentMessage;